module.exports = __webpack_public_path__ + "static/img/about_us_SB.563b844.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about_us_SB.png
// module id = DmmL
// module chunks = 0